import { render, staticRenderFns } from "./CreateEditRichMenu.vue?vue&type=template&id=7e57f077"
import script from "./CreateEditRichMenu.vue?vue&type=script&lang=js"
export * from "./CreateEditRichMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports